import { render } from "./OrgServicePackages.vue.js?vue&type=template&id=6917f5cf!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgServicePackages.vue?vue&type=template&id=6917f5cf"
import script from "./OrgServicePackages.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgServicePackages.vue?vue&type=script&lang=js"
export * from "./OrgServicePackages.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgServicePackages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/OrgServicePackages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6917f5cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6917f5cf', __exports__)) {
    api.reload('6917f5cf', __exports__)
  }
  
  module.hot.accept("./OrgServicePackages.vue.js?vue&type=template&id=6917f5cf!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./OrgServicePackages.vue?vue&type=template&id=6917f5cf", () => {
    api.rerender('6917f5cf', render)
  })

}


export default __exports__